import PropTypes from 'prop-types';
import LinearProgress from '@mui/material/LinearProgress';

import classes from './UserProgressBar.module.css';

const UserProgressBar = props => {
  let allActivities = 0;
  let completeActivities = 0;
  props.userAditionalTrack.userTrack.map(progress => {
    if (progress.media_play == 2) {
      completeActivities += 1;
    }
    if (progress.media_eval == 2) {
      completeActivities += 1;
    }
    if (progress.media_coeval >= 3) {
      completeActivities += 1;
    }
    if (progress.media_quiz == 2) {
      completeActivities += 1;
    }
  });
  if (props.lessons.separators) {
    props.lessons.separators.map(folder => {
      folder.lessons.map(video => {
        allActivities += 1;
        if (video.hasEvaluation) {
          allActivities += 2;
        }
        if (video.idQuiz > 0) {
          allActivities += 1;
        }
      });
    });
  }
  if (props.lessons.lessons) {
    props.lessons.lessons.map(video => {
      allActivities += 1;
      if (video.hasEvaluation) {
        allActivities += 2;
      }
      if (video.idQuiz > 0) {
        allActivities += 1;
      }
    });
  }

  // TODO: Eliminar estas lineas cuando el back mande bien la info
  if (completeActivities > allActivities) {
    completeActivities = allActivities;
  }

  const progress = (completeActivities * 100) / allActivities;

  return (
    <div className={classes.progressBarContainer}>
      <span className={classes.progressText}>
        {progress.toFixed(2)}% Completado
      </span>
      <LinearProgress
        classes={{
          barColorPrimary: classes.linearBarColorUser
        }}
        className={classes.progressBarUser}
        variant="determinate"
        value={progress.toFixed(2)}
      />
    </div>
  );
};

UserProgressBar.propTypes = {
  // eslint-disable-next-line react/require-default-props
  userAditionalTrack: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  lessons: PropTypes.object
};

export default UserProgressBar;
